import React from "react"
import { loginGuardProps } from "../../helpers/auth"

const FavoritesSelector = ({ onSave, onLoad, isLoggedIn = false }) => (
  <>
    <div className="subsection-label section-divider">Favorites</div>
    <div className="choices-input-actions">
      <button
        className="btn-base btn-secondary choices-input-btn"
        onClick={onSave}
        {...loginGuardProps(isLoggedIn, "Save favorite to your account")}
      >
        Save
      </button>
      <button
        className="btn-base btn-secondary choices-input-btn"
        onClick={onLoad}
        {...loginGuardProps(isLoggedIn, "Load a saved favorite")}
      >
        Load
      </button>
    </div>
  </>
)

export default FavoritesSelector
